/* eslint-disable indent */
import React, { useRef, useEffect } from "react";
import { Button, Spin, message } from "antd";
import print_icon from "../../assests/images/master/print.svg";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import { useState } from "react";
import API from "../../api";
import { APIs } from "../../utils/worker";
import { PrintManifest } from "../../components/PrintManifest";
import { capitalize, camelCase } from "../../utils";
function PrintGenerateManifest() {
  const componentRef = useRef();
  const manifestId = useParams();
  const [loading, setLoading] = useState(false);
  const [printData, setPrintData] = useState();
  const packetDataDox = printData?.shipmentScanDtos?.filter(
    (data) => data?.shipmentDetails?.type == "dox"
  );
  const packetData = printData?.shipmentScanDtos?.map(
    (data) => data?.packetsdto
  );
  // const packetDataNonDoxWithChild = printData?.shipmentScanDtos?.filter(
  //   (data) =>
  //     data?.shipmentDetails?.type == "non-dox" &&
  //     data?.shipmentDetails?.childShipmentDetails.length !== 0
  // );
  const packetDataNonDoxWithChild = printData?.shipmentScanDtos.filter(
    (data) => {
      if (data?.childShipmentResponseDto !== null)
        return data?.childShipmentResponseDto;
    }
  );
  console.log(packetDataNonDoxWithChild);
  const packetDataNonDoxWithNoChild = printData?.shipmentScanDtos?.filter(
    (data) =>
      data?.shipmentDetails?.childShipmentDetails?.length === 0 &&
      data?.shipmentDetails?.type == "non-dox"
  );
  useEffect(() => {
    getManifestById();
  }, [manifestId]);

  const getManifestById = async () => {
    setLoading(true);
    let response = await API.Api(
      `${APIs.baseURL}/last-mile-manifest-service/v1/manifest/${manifestId?.id}`
    ).getWithAllHeaders();
    if (response.status) {
      setLoading(false);
      setPrintData(response?.response?.data);
    } else {
      if (!response.status) {
        message.error(response.response.data.message || "Network error");
        setLoading(false);
      }
    }
  };

  const columnsWOChild = [
    {
      title: "AWB No",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{text?.shipmentDetails?.awbNumber || "------"}</div>
      ),
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{`${text?.shipmentDetails?.weight} Kg` || "------"}</div>
      ),
    },
    {
      title: "Mode",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{capitalize(text?.shipmentDetails?.travelBy) || "------"}</div>
      ),
    },
  ];
  const columnsWithChild = [
    {
      title: "AWB No",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{text?.childShipmentResponseDto?.awbNumber || "------"}</div>
      ),
    },
    {
      title: "Child AWB No",
      dataIndex: "",
      key: "",
      render: (text) => <>{text?.childShipmentResponseDto?.childAwbNumber}</>,
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{`${text?.childShipmentResponseDto?.weight} Kg` || "------"}</div>
      ),
    },
    {
      title: "Mode",
      dataIndex: "",
      key: "",
      render: () => <div>{capitalize(printData?.travelBy) || "------"}</div>,
    },
  ];
  const columnsDox = [
    {
      title: "AWB No",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{text?.shipmentDetails?.awbNumber || "------"}</div>
      ),
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{`${text?.shipmentDetails?.weight || "------"} Kg`}</div>
      ),
    },
    {
      title: "Mode",
      dataIndex: "",
      key: "",
      render: (text) => (
        <div>{camelCase(text?.shipmentDetails?.travelBy) || "------"}</div>
      ),
    },
  ];
  const packets = [
    {
      title: "Packet ID",
      dataIndex: "",
      key: "",
      render: (text) => <div>{text?.packetBarcode}</div>,
    },
    {
      title: "Packet Content",
      dataIndex: "",
      key: "",
      render: (text) => (
        <>
          {text?.packetShipments?.map((data, idx) => (
            <div key={idx}>{data?.awbNo}</div>
          ))}
        </>
      ),
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        <>
          {text?.packetShipments?.map((data, idx) => (
            <div key={idx}>{`${data?.weight} Kg`}</div>
          ))}
        </>
      ),
    },
    {
      title: "Mode",
      dataIndex: "",
      key: "",
      render: (record) => <div>{capitalize(record?.travelBy)}</div>,
    },
  ];

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <Spin spinning={loading}>
      <div className="p-2">
        <div className="print-consolidated-manifest">
          <div className="heading-lcr p-1-5">Print Manifest</div>
          <div className="lcr-report-wrapper">
            <div className="download-btn">
              <Button onClick={printHandle}>
                <img src={print_icon} /> PRINT
              </Button>
            </div>
            <PrintManifest
              componentRef={componentRef}
              packetAndShipmt={printData}
              // fromLocation={fromLocation}
              // toLocation={toLocation}
              manifestId={manifestId}
              columnsWOChild={columnsWOChild}
              packetDataNonDoxWithNoChild={packetDataNonDoxWithNoChild}
              columnsWithChild={columnsWithChild}
              packetDataNonDoxWithChild={packetDataNonDoxWithChild}
              columnsDox={columnsDox}
              packetDataDox={packetDataDox}
              packets={packets}
              packetData={packetData}
              Boolean={Boolean}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default PrintGenerateManifest;
